module.exports = __webpack_public_path__ + "static/img/icon-level-06.8315f647.svg";